const config = {
    development: {
        SHARE_API_BASE: "http://share.beta.dokiv.com/api",
        API_BASE: "http://api.beta.dokiv.com/v1",
        APP_URL: "https://app.beta.dokiv.com"
    },
    production: {
        SHARE_API_BASE: "https://share.dokiv.com/api",
        API_BASE: "https://api.dokiv.com/v1",
        APP_URL: "https://share.dokiv.com"
    }
};

const environment = process.env.NODE_ENV || 'development';
module.exports = config[environment];
